import axios from '../axios/redditlikeApi'

const fetchNotifications = (page, pageSize) => axios.get(`/notifications?page=${page}&size=${pageSize}`)

const getNotificationById = (notificationId) => axios.get(`/notifications/${notificationId}`)

const createNotification = form => axios.post('/notifications', form)

const updateNotification = (notificationId, form) => axios.patch(`/notifications/${notificationId}`, form)

const deleteNotification = notificationId => axios.delete(`/notifications/${notificationId}`)

export default {
  fetchNotifications,
  getNotificationById,
  createNotification,
  updateNotification,
  deleteNotification
}
